import { ExcelPresentation } from "@common/schemas/domains/reportSettings/excel-presentation.schema";
import { NumberFormatValues } from "@common/schemas/domains/reportSettings/number-format-setting.schema";
import { ReportPresentationChrome } from "@common/schemas/domains/reportSettings/report-presentation.schema";
import { NumberFormatAmountScale } from "@common/types/reports/number-format-settings";

interface BuildExcelPresentationParams {
    chrome: ReportPresentationChrome;
    numberFormat: NumberFormatValues;
}

export function shouldShowRoundingDisclosure(
    numberFormat: NumberFormatValues,
): boolean {
    return (
        numberFormat.amountScale !== NumberFormatAmountScale.FULL ||
        numberFormat.decimalPlaces === 0
    );
}

export function buildExcelPresentation({
    chrome,
    numberFormat,
}: BuildExcelPresentationParams): ExcelPresentation {
    return {
        chrome,
        numberFormat,
        showRoundingDisclosure: shouldShowRoundingDisclosure(numberFormat),
    };
}
